module.exports = __webpack_public_path__ + "media/images/client_logos/logo_bordeaux_200-50e27c6ec8bfda231bb3a954a53a64c5.png";